// extracted by mini-css-extract-plugin
export default {"contactBlock":"Contacts_contactBlock__2nJOs","contactsContainer":"Contacts_contactsContainer__In5Za","contactForm":"Contacts_contactForm__vxpjd"};